export default "__VITE_ASSET__C_Zpmnc0__"